import React from 'react';
import SectionText from '../presentational/SectionText';
import DotPoints from '../presentational/DotPoints';

import cx from 'classnames';
import { Track, TrackedDiv, TrackDocument } from 'react-track';
import { topTop,
        topBottom,
        centerCenter,
        topCenter,
        bottomBottom,
        bottomTop,
        getDocumentRect,
        getDocumentElement,
        calculateScrollY } from 'react-track/tracking-formulas';
import { tween, combine } from 'react-imation';
import { rgb, rgba, scale, rotate,
        px, percent, translate3d } from 'react-imation/tween-value-factories';

import data from '../../core/data';
import herbs from "../../images/herbal-peel/green-powder.jpg";

function TreatmentContainer(props) {
  return (

    <section id="treatment">
      <div className="container">
        <TrackDocument formulas={[getDocumentElement, getDocumentRect, calculateScrollY,
                                 topTop, topBottom, topCenter, centerCenter]}>
        {(documentElement, documentRect, scrollY, topTop,
          topBottom, topCenter, centerCenter, bottomBottom, bottomTop) =>
          <div className="row">
            <Track component="div" className="col-md-5 body" formulas={[topBottom, topCenter]}>
              {(DIV, posTopBottom, posTopCenter) =>
              <DIV
                style={tween(scrollY, {
                  [posTopBottom-50]: { transform: translate3d(-100,0,0), opacity: 0 },
                  [posTopCenter]: { transform: translate3d(0,0,0), opacity: 1 }
                })}>
                <h1 className="header">CPeel™</h1>
                <p>{ data.index.treatment.body }</p>
                <Track component="div" formulas={[topBottom, topCenter]}>
                  {(DIV, posTopBottom, posTopCenter) =>
                    <DIV>
                      <DotPoints className={cx('herbs',{'animated': scrollY > (posTopCenter-150)})} array={ data.index.treatment.points } />
                    </DIV>
                }</Track>
              </DIV>
            }</Track>
            <Track component="div" className="col-md-7 green-powder" formulas={[topBottom, topCenter]}>
              {(DIV, posTopBottom, posTopCenter) =>
              <DIV
                style={tween(scrollY, {
                  [posTopCenter-300]: { transform: translate3d(100,0,0), opacity: 0 },
                  [posTopCenter]: { transform: translate3d(0,0,0), opacity: 1 }
                })}>
                <img className="hidden-xs" src={ herbs } alt="Green herbal powder" />
              </DIV>
            }</Track>
          </div>
        }</TrackDocument>
      </div>
      <div className="treatment2 image-bg">
        <div className="background-cover">
          <div className="container">
            <p>{ data.index.treatment.body2 }</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TreatmentContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/TreatmentContainer.jsx
 **/